module.exports = __webpack_public_path__ + "static/media/Astronaut.4db29c92.jpg";